import { useLocation, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { StyledListItemButton, ItemContainer, StyledIcon } from './DrawerStyled';

const DrawerItem = ({ route, onClick, endIcon = null, isHeader = false }) => {
    const location = useLocation();
    const handleClick = (event) => {
        if (route.items) event.preventDefault();
        onClick?.(event);
    };

    const isActive = location.pathname === route.path;
    const isDisabled = route.disabled;

    return (
        <StyledListItemButton component={Link} to={route.path} onClick={handleClick} className={isActive ? 'active' : ''}>
            <ItemContainer className={isDisabled ? 'disabled' : ''}>
                <StyledIcon $isHeader={isHeader} disabled={isDisabled}>
                    {route.Icon && <route.Icon />}
                </StyledIcon>
                <div>{route.text}</div>
            </ItemContainer>
            {endIcon}
        </StyledListItemButton>
    );
};

DrawerItem.propTypes = {
    route: PropTypes.object.isRequired,
    onClick: PropTypes.func,
    endIcon: PropTypes.node,
    isHeader: PropTypes.bool,
};

export default DrawerItem;
